// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="sessions.SessionsCountChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="sessions.SessionsLengthChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="sessions.SessionsLengthPerDayChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="sessions.SessionsLengthSumInFirstDayChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;